import React, { useState, useEffect } from "react";
import { Container, Navbar, Nav, Modal } from "react-bootstrap";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Login from "./login/login";
import { FaSearch, FaUser } from "react-icons/fa";
import { createClient } from "@supabase/supabase-js";
import LoadingSpinner from "./loadingSpinner/loadingSpinner";
import Logo from "../assets/img/logo/Frame 4.png";
import { PiSignIn, PiSignOut } from "react-icons/pi";
import { TiDocument } from "react-icons/ti";
import axiosRetry from "axios-retry";
import { API, api_url, generateAuthHeader } from "../util/util";
import axios from "axios";

axiosRetry(axios, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
});

const supabaseUrl = process.env.REACT_APP_SUPABAE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASEKEY;
const supabase = createClient(supabaseUrl, supabaseKey);

function Headers({ loading }) {
  const location = useLocation();  // Move this to the top
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const loggedIn = localStorage.getItem("login") === "true";
    setIsLoggedIn(loggedIn);
  }, []);

  const showSearchBar = isLoggedIn && location.pathname !== "/search-bar" && location.pathname !== "/digital-library";


  useEffect(() => {
    // Check if user is already logged in
    const checkUser = async () => {
      const user = supabase.auth.getUser();
      console.log("user", user);
      if (user) {
        setIsLoggedIn(true);
      }
    };

    // Initialize the check
    checkUser();

    // Add listener for auth state changes
    const authListener = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "SIGNED_OUT") {
        // Clear session from local storage
        localStorage.removeItem("login");
        localStorage.removeItem("sb-hnfcpioavnlsyqepkgxo-auth-token");
        setIsLoggedIn(false);
        navigate("/");
      }
    });
  }, [navigate]);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  async function handleLogout() {
    const { error } = await supabase.auth.signOut();
    localStorage.removeItem("login");
    localStorage.removeItem("sb-hnfcpioavnlsyqepkgxo-auth-token");
    setIsLoggedIn(false);
    navigate("/");
  }

  useEffect(() => {
    const loggedIn = localStorage.getItem("login");
    if (loggedIn === "true") {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);


  const [query, setQuery] = useState("");
  const [paramater, setParameter] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const handleChange = async (e) => {
    const { value } = e.target;
    setQuery(value);

    if (value.trim() === "") {
      setSuggestions([]);
      return;
    }

    const url = `${api_url}/${API.ENDPOINTS.search}?name=${value}`;
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: generateAuthHeader(),
        },
      });

      if (response.status === 200) {
        setSuggestions(response.data.companies);
      } else {
        console.error("Unexpected response");
      }
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  const handleClick = (suggestion) => {
    setQuery(suggestion.name);
    setParameter(suggestion.permalink);
    setSuggestions([]);
    window.location.href = `/details?query=${suggestion.permalink}`;
  };

  return (
    <>
      <div className="scroll">
        <Navbar expand="lg" className="navbar container-height p-3 d-flex justify-content-between align-items-center">
          <Container fluid>
            <div className="loading-logo">
              <div className="logo me-auto d-flex">
                <NavLink to="/">
                  <img className="logo-hading" src={Logo} />
                </NavLink>
                {showSearchBar && (
                  <>
                    <div className="Search-input-container-hedr">
                      <FaSearch className="search-icon-header" />
                      <input
                        className="Search-input-header"
                        type="text"
                        value={query}
                        onChange={handleChange}
                        placeholder="Search by company name"
                      />
                    </div>
                    <ul className="suggestions-list-header">
                      {suggestions.map((suggestion, index) => (
                        <li key={index} onClick={() => handleClick(suggestion)}>
                          <span className="small-description">
                            {suggestion.name}
                          </span>
                          <br />
                          <span>
                            {suggestion.description}
                          </span>
                          <hr />
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
              {loading ? <LoadingSpinner /> : null}
            </div>
            <Navbar.Toggle aria-controls="navbarScroll" />
            <Navbar.Collapse id="navbarScroll " >
              <Nav
                className="me-auto my-2 my-lg-0 w-100 d-flex justify-content-end align-items-center"
                style={{ maxHeight: '100px' }}
                navbarScroll
              >
                {isLoggedIn ? (
                  <>
                    <NavLink to="/digital-library" className="collasible-nav-button-Digital">
                      <TiDocument className="signicon me-2" />
                      Digital Library
                    </NavLink>

                    <Nav.Link
                      onClick={handleLogout}
                      className="btn collasible-nav collasible-signout"
                    >
                      <PiSignOut className="signicon" />Sign Out
                    </Nav.Link>
                  </>
                ) : (
                  <Nav.Link
                    onClick={toggleModal}
                    className="btn collasible-nav m-0 p-0 d-flex align-items-center"
                  >
                    <PiSignIn className="signicon" />Sign In
                  </Nav.Link>
                )}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <Modal show={isModalOpen} onHide={toggleModal}>
          <Modal.Header className="modalHeader-login" closeButton />
          <div className="main-svg-user d-flex justify-content-center">
            <FaUser className="user-svg" />
          </div>
          <Modal.Body>
            <Login />
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default Headers;